import axios from 'axios'

import {
  LOW_INVENTORY_REQUEST,
  LOW_INVENTORY_SUCCESS,
  LOW_INVENTORY_FAIL
} from '../constants/reportConstants'

import { API_URL } from '../apiUrl.js'

export const getLowInventory =
  (lowpageNumber = '') =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({
        type: LOW_INVENTORY_REQUEST
      })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.get(
        `${API_URL}/reports/lowinventory?lowpageNumber=${lowpageNumber}`,
        config
      )

      dispatch({
        type: LOW_INVENTORY_SUCCESS,
        payload: data
      })
    } catch (error) {
      dispatch({
        type: LOW_INVENTORY_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }
